import React, { useEffect, useState } from "react";
import { showErrorToast, showSuccessToast } from "../../assets/toastUtils";
import styles from "./PackageQueryForm.module.scss";
import locationIcon from "../../assets/images/location_icon.png";
import destinationIcon from "../../assets/images/experienc_icon.png";
import securityIcon from "../../assets/images/security_icon.png";
import customerIcon from "../../assets/images/customer_icon.png";
import MultiSelectInputSingleId from "../MultiSelectInputSingleId/MultiSelectInputSingleId";
import { useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import { format } from "date-fns";

const ActivityQueryFormPopup = ({
  package_id,
  setshowRatePopup,
  typeDetail,
  activityDestination,
  singleActivityData
}) => {
  const [showRatePopup, setShowRatePopup] = useState(false);
  const location = useLocation();
  const userType = localStorage.getItem("userType");

  const [formErrors, setFormErrors] = useState({});

  const [loader, setLoader] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    date_information: "",
    source: "website",
    adult: "",
    time_slot_information: "",
    content: "",
    source_type: "",
    guide_required: "",

    type: typeDetail ? typeDetail : "package",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleShowRatePopup = (e) => {
    e.stopPropagation();
    setshowRatePopup(false);
  };

  const validate = () => {
    const errors = {};
    // Add validation logic for each form field
    // if (currentStep === 1) {
    if (!formData.name.trim()) {
      errors.name = "required";
    }
    if (!formData.company_name.trim()) {
      errors.company_name = "required";
    }
    if (!formData.phone.trim()) {
      errors.phone = "is required";
    }
    if (!formData.querry_detail) {
      errors.querry_detail = "required";
    }
    if (!formData.email) {
      errors.email = "required";
    }
    if (!formData.travel_date) {
      errors.travel_date = "required";
    }
    // }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const baseUrl = 'https://www.mountainmysteries.com' + window?.location?.pathname;
  const handleSubmit = async (e) => {
    e.preventDefault();

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);
    const params = new URLSearchParams(location.search);

    const adult = params.get("adult");
    const sourceType =
      userType === "agent"
        ? "agent"
        : userType === "vendor"
          ? "vendor"
          : "customer";

    const rawData = {
      name: formData?.name,
      email: formData?.email,
      phone_information: formData?.phone,
      content: formData?.content,
      source: formData?.source,
      source_type: sourceType,
      type: formData?.type,

      time_slot_information: formData?.time_slot_information,
      // date_information: formData?.date_information,
      date_information: formData.date_information
        ? format(formData.date_information, 'yyyy-MM-dd')
        : "",
      guide_required_information: formData?.guide_required,
      paxes_information: adult ? adult : 1,
      activity_destination_information: activityDestination
        ? activityDestination
        : "shimla",
      package_name_information: singleActivityData?.activityName,
      package_id_information: singleActivityData?.activityId,
      package_url_information: baseUrl,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/query/create`,
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(rawData),
          redirect: "follow",
        }
      );
      const result = await response.json();
      if (result.success) {
        showSuccessToast(result.message || "Form submitted successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          date_information: "",
          source: "website",
          adult: "",
          time_slot_information: "",
          content: "",
          source_type: "",
          guide_required: "",
        });
        setshowRatePopup(false);
      } else {
        showErrorToast(
          result.message || "An error occurred. Please try again."
        );
      }
    } catch (error) {
      showErrorToast("An error occurred. Please try again.");
      console.error(error);
    }
  };

  // const fetchDestinations = async () => {
  //     setLoader(true);
  //     const myHeaders = new Headers();
  //     myHeaders.append("Accept", "application/json");
  //     myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
  //     const formData = new FormData();
  //     // formData.append("limit", 10);

  //     const requestOptions = {
  //         method: "POST",
  //         headers: myHeaders,
  //         redirect: "follow",
  //         body: formData,
  //     };

  //     try {
  //         const response = await fetch(
  //             `${process.env.REACT_APP_BASE_URL}/api/v1/destinations/fetch`,
  //             requestOptions
  //         );
  //         if (!response.ok) {
  //             throw new Error(`HTTP error! Status: ${response.status}`);
  //         }
  //         const result = await response.json();
  //         setDestinationData(result?.data);
  //     } catch (error) {
  //         console.error("Error fetching data:", error);
  //     } finally {
  //         setLoader(false);
  //     }
  // };

  // useEffect(() => {
  //     fetchDestinations();
  // }, []);

  // console.log(destinationData, 'destinationData');

  return (
    <div className="bg-backdrop packagequery_form_backdrop">
      <div className={styles.new_popup_flex}>
        <div className={styles.new_popup_colored}>
          <div className="flex align_items_center h-full">
            <div>
              <h4>Over 22+ Years of Experience</h4>
              <div className={styles.choose_us}>
                <div className={styles.highlight}>
                  {/* <img src={locationIcon} alt="location-icon" /> */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <mask id="mask0_6838_7100" maskUnits="userSpaceOnUse" x="0" y="0" width="30" height="30">
                      <rect width="30" height="30" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6838_7100)">
                      <path d="M15 26.25C13.4471 26.25 11.9864 25.954 10.6178 25.3619C9.24927 24.7696 8.05854 23.9671 7.04563 22.9544C6.03292 21.9415 5.23042 20.7507 4.63812 19.3822C4.04604 18.0136 3.75 16.5529 3.75 15C3.75 12.9935 4.2376 11.1333 5.21281 9.41937C6.18802 7.70542 7.53771 6.34125 9.26188 5.32688C9.29875 5.53042 9.3325 5.73521 9.36312 5.94125C9.39354 6.14708 9.44156 6.37656 9.50719 6.62969C8.0874 7.5624 6.98125 8.76396 6.18875 10.2344C5.39625 11.7048 5 13.2933 5 15C5 17.7917 5.96875 20.1563 7.90625 22.0938C9.84375 24.0313 12.2083 25 15 25C17.7917 25 20.1562 24.0313 22.0938 22.0938C24.0312 20.1563 25 17.7917 25 15C25 13.2933 24.5998 11.6996 23.7994 10.2188C22.9988 8.73792 21.8781 7.53115 20.4375 6.59844C20.5031 6.36136 20.5552 6.14386 20.5938 5.94594C20.6323 5.74802 20.6724 5.54167 20.7141 5.32688C22.4384 6.34125 23.7922 7.70427 24.7753 9.41594C25.7584 11.1274 26.25 12.9887 26.25 15C26.25 16.5529 25.954 18.0136 25.3619 19.3822C24.7696 20.7507 23.9671 21.9415 22.9544 22.9544C21.9415 23.9671 20.7507 24.7696 19.3822 25.3619C18.0136 25.954 16.5529 26.25 15 26.25ZM15 21.25C13.2692 21.25 11.7948 20.641 10.5769 19.4231C9.35896 18.2052 8.75 16.7308 8.75 15C8.75 14.1281 8.91948 13.3013 9.25844 12.5194C9.5974 11.7373 10.0802 11.0561 10.7069 10.4759C10.779 10.6764 10.8494 10.8795 10.9181 11.0853C10.9871 11.2914 11.0697 11.5281 11.1659 11.7956C10.7876 12.2427 10.4987 12.7419 10.2994 13.2931C10.0998 13.8446 10 14.4135 10 15C10 16.375 10.4896 17.5521 11.4688 18.5312C12.4479 19.5104 13.625 20 15 20C16.375 20 17.5521 19.5104 18.5312 18.5312C19.5104 17.5521 20 16.375 20 15C20 14.3975 19.8962 13.8285 19.6887 13.2931C19.4812 12.7579 19.1883 12.2588 18.81 11.7956C18.8806 11.6002 18.9075 11.5333 18.8906 11.595C18.8738 11.6567 18.9975 11.2756 19.2619 10.4519C19.9046 11.0321 20.3967 11.7172 20.7381 12.5072C21.0794 13.2972 21.25 14.1281 21.25 15C21.25 16.7308 20.641 18.2052 19.4231 19.4231C18.2052 20.641 16.7308 21.25 15 21.25ZM14.2306 10C13.4598 7.68271 12.9786 6.14229 12.7872 5.37875C12.5957 4.615 12.5 3.86375 12.5 3.125C12.5 2.42625 12.742 1.8349 13.2259 1.35094C13.7099 0.866979 14.3013 0.625 15 0.625C15.6987 0.625 16.2901 0.866979 16.7741 1.35094C17.258 1.8349 17.5 2.42625 17.5 3.125C17.5 3.86375 17.4043 4.615 17.2128 5.37875C17.0214 6.14229 16.5402 7.68271 15.7694 10H14.2306ZM15 16.875C14.4727 16.875 14.0284 16.6943 13.6672 16.3328C13.3057 15.9716 13.125 15.5273 13.125 15C13.125 14.4727 13.3057 14.0284 13.6672 13.6672C14.0284 13.3057 14.4727 13.125 15 13.125C15.5273 13.125 15.9716 13.3057 16.3328 13.6672C16.6943 14.0284 16.875 14.4727 16.875 15C16.875 15.5273 16.6943 15.9716 16.3328 16.3328C15.9716 16.6943 15.5273 16.875 15 16.875Z" fill="#009A50" />
                    </g>
                  </svg>
                  <span>All in one platform</span>
                </div>
                <div className={styles.highlight}>
                  {/* <img src={destinationIcon} alt="destination-icon" /> */}

                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <mask id="mask0_6838_7106" maskUnits="userSpaceOnUse" x="0" y="0" width="30" height="30">
                      <rect width="30" height="30" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6838_7106)">
                      <path d="M7.01937 25C6.44396 25 5.96354 24.8073 5.57812 24.4219C5.19271 24.0365 5 23.556 5 22.9806V7.01937C5 6.44396 5.19271 5.96354 5.57812 5.57812C5.96354 5.19271 6.44396 5 7.01937 5H22.9806C23.556 5 24.0365 5.19271 24.4219 5.57812C24.8073 5.96354 25 6.44396 25 7.01937V22.9806C25 23.556 24.8073 24.0365 24.4219 24.4219C24.0365 24.8073 23.556 25 22.9806 25H7.01937ZM7.01937 23.75H22.9806C23.1731 23.75 23.3495 23.6699 23.5097 23.5097C23.6699 23.3495 23.75 23.1731 23.75 22.9806V7.01937C23.75 6.82687 23.6699 6.65052 23.5097 6.49031C23.3495 6.3301 23.1731 6.25 22.9806 6.25H7.01937C6.82687 6.25 6.65052 6.3301 6.49031 6.49031C6.3301 6.65052 6.25 6.82687 6.25 7.01937V22.9806C6.25 23.1731 6.3301 23.3495 6.49031 23.5097C6.65052 23.6699 6.82687 23.75 7.01937 23.75ZM9.375 20.625H20.8172L17.2838 15.9134L14.0144 20.0481L11.8269 17.4038L9.375 20.625Z" fill="#009A50" />
                    </g>
                  </svg>
                  <span>Expertise in Mountain Destinations</span>
                </div>
                <div className={styles.highlight}>
                  {/* <img src={securityIcon} alt="security-icon" /> */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <mask id="mask0_6838_7112" maskUnits="userSpaceOnUse" x="0" y="0" width="30" height="30">
                      <rect width="30" height="30" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6838_7112)">
                      <path d="M15.4259 15.2403L17.8368 13.7859L20.2477 15.2403L19.594 12.4953L21.7334 10.6516L18.9331 10.4181L17.8368 7.83656L16.7406 10.4181L13.9402 10.6516L16.0796 12.4953L15.4259 15.2403ZM21.0674 23.0769H22.9234C22.9217 23.3781 22.8199 23.6353 22.6181 23.8484C22.4162 24.0616 22.1621 24.1939 21.8559 24.2453L7.72618 26.0216C7.1668 26.0936 6.66722 25.9602 6.22743 25.6213C5.78743 25.2825 5.53378 24.8334 5.46649 24.2741L3.93055 12.1322C3.86326 11.5728 4.00191 11.0665 4.34649 10.6131C4.69107 10.1596 5.14295 9.90708 5.70212 9.85563L6.92337 9.76438V11.0144L5.89462 11.0984C5.67024 11.1145 5.49389 11.2067 5.36555 11.375C5.23743 11.5433 5.18941 11.7397 5.22149 11.9641L6.71649 24.1056C6.74857 24.33 6.84472 24.5064 7.00493 24.6347C7.16535 24.7628 7.35774 24.8108 7.58212 24.7787L21.0674 23.0769ZM11.4424 20.5769C10.8672 20.5769 10.3869 20.3842 10.0015 19.9987C9.61607 19.6133 9.42337 19.133 9.42337 18.5578V5.76937C9.42337 5.19396 9.61607 4.71354 10.0015 4.32812C10.3869 3.94271 10.8672 3.75 11.4424 3.75H24.2309C24.8063 3.75 25.2867 3.94271 25.6721 4.32812C26.0575 4.71354 26.2502 5.19396 26.2502 5.76937V18.5578C26.2502 19.133 26.0575 19.6133 25.6721 19.9987C25.2867 20.3842 24.8063 20.5769 24.2309 20.5769H11.4424ZM11.4424 19.3269H24.2309C24.4552 19.3269 24.6396 19.2548 24.784 19.1106C24.9282 18.9665 25.0002 18.7822 25.0002 18.5578V5.76937C25.0002 5.545 24.9282 5.36062 24.784 5.21625C24.6396 5.07208 24.4552 5 24.2309 5H11.4424C11.2181 5 11.0338 5.07208 10.8896 5.21625C10.7454 5.36062 10.6734 5.545 10.6734 5.76937V18.5578C10.6734 18.7822 10.7454 18.9665 10.8896 19.1106C11.0338 19.2548 11.2181 19.3269 11.4424 19.3269Z" fill="#009A50" />
                    </g>
                  </svg>
                  <span> Handpicked Stays & Experiences</span>
                </div>
                <div className={styles.highlight}>
                  {/* <img src={customerIcon} alt="customer-icon" /> */}

                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <mask maskUnits="userSpaceOnUse" x="0" y="0" width="30" height="30">
                      <rect width="30" height="30" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6838_7118)">
                      <path d="M13.75 18.7502H16.25V15.6252H19.375V13.1252H16.25V10.0002H13.75V13.1252H10.625V15.6252H13.75V18.7502ZM15 26.2021C12.4887 25.4569 10.4026 23.9356 8.74156 21.6383C7.08052 19.341 6.25 16.7533 6.25 13.8752V7.1155L15 3.84644L23.75 7.1155V13.8752C23.75 16.7533 22.9195 19.341 21.2584 21.6383C19.5974 23.9356 17.5113 25.4569 15 26.2021ZM15 24.8752C17.1667 24.1877 18.9583 22.8127 20.375 20.7502C21.7917 18.6877 22.5 16.396 22.5 13.8752V7.96894L15 5.1805L7.5 7.96894V13.8752C7.5 16.396 8.20833 18.6877 9.625 20.7502C11.0417 22.8127 12.8333 24.1877 15 24.8752Z" fill="#009A50" />
                    </g>
                  </svg>
                  <span>Safety & security</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <form onSubmit={handleSubmit} className={styles.new_popup_form}>
          <h4
            style={{
              fontSize: "18px",
              fontWeight: "600",
              textTransform: "uppercase",
              color: '#016937'
            }}
          >
            Our expert will get in touch with you shortly
          </h4>
          <div
            className="dashboard_checkin_modal_close_btn"
            onClick={handleShowRatePopup}
            style={{
              cursor: "pointer",
              position: "absolute",
              top: "10px",
              right: "10px",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M1 12.7464L13 0.851318"
                stroke="#AAAAAA"
                strokeWidth="1.2"
              />
              <path
                d="M13 12.7463L0.999999 0.851296"
                stroke="#AAAAAA"
                strokeWidth="1.2"
              />
            </svg>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            <div className="flex flex_gap_10">
              <div className={styles.package_query_input_50}>
                <label htmlFor="name">Name:</label>
                <input
                  // required
                  className="w-full"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Your Name"
                  style={{
                    padding: "10px",
                    // borderRadius: "4px",
                    // border: "1px solid #ccc",
                    ...(formErrors.name && {
                      backgroundColor: "#ff000040",
                      border: "1px solid red",
                    }),
                  }}
                />
              </div>

              <div className={styles.package_query_input_50}>
                <label htmlFor="phone">Phone:</label>
                <input
                  className="w-full"
                  type="number"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="Phone"
                  style={{
                    padding: "10px",
                    // borderRadius: "4px",
                    // border: "1px solid #ccc",
                    ...(formErrors.phone && {
                      backgroundColor: "#ff000040",
                      border: "1px solid red",
                    }),
                  }}
                />
              </div>
            </div>

            <div className="flex flex_gap_10">
              <div className={styles.package_query_input_100}>
                <label htmlFor="email">Email:</label>
                <input
                  className="w-full"
                  type="text"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Email"
                  style={{
                    padding: "10px",
                    // borderRadius: "4px",
                    // border: "1px solid #ccc",
                    ...(formErrors.email && {
                      backgroundColor: "#ff000040",
                      border: "1px solid red",
                    }),
                  }}
                />
              </div>
              {/* <div className={styles.package_query_input_50}>
                                <label htmlFor="source_type">Are you Agent:</label>
                                <select
                                    style={{
                                        padding: "10px",
                                        ...(formErrors.source_type && {
                                            backgroundColor: "#ff000040",
                                            border: "1px solid red",
                                        }),
                                    }}
                                    className="w-full"
                                    name="source_type"
                                    value={formData.source_type}
                                    onChange={handleInputChange}
                                >
                                    <option value="" disabled>
                                        Select an option
                                    </option>
                                    <option value="agent">Yes</option>
                                    <option value="customer">No</option>
                                </select>
                            </div> */}
            </div>

            <div className="flex flex_gap_10">
              <div className={styles.package_query_input_50}>
                <label htmlFor="date_information">Date:</label>
                {/* <input
                  className="w-full"
                  type="date"
                  name="date_information"
                  value={formData.date_information}
                  onChange={handleInputChange}
                  min={new Date().toISOString().split("T")[0]}
                  placeholder="Start Date"
                  style={{
                    padding: "10px",
                    // borderRadius: "4px",
                    // border: "1px solid #ccc",
                    ...(formErrors.date_information && {
                      backgroundColor: "#ff000040",
                      border: "1px solid red",
                    }),
                  }}
                /> */}

                <div className={styles.new_date_picker_wrapper}>
                  <DatePicker
                    selected={formData?.date_information}
                    // onChange={(date) => setFormData(date)}
                    onChange={(date) => setFormData(prev => ({
                      ...prev,
                      date_information: date
                    }))}
                    portalId="root-portal NewUIReactDatePicker PackageQueryFormDatePickerWrapper"
                    popperPlacement="bottom-start"
                    className="PackageQueryFormDatePickerWrapper2"
                    minDate={new Date()}
                    dateFormat="dd MMM, yyyy"
                    placeholderText={
                      formData?.date_information ? format(formData?.date_information, "dd MMM, yyyy") : "Date"
                    }
                  />
                </div>
              </div>

              <div className={styles.package_query_input_50}>
                <label htmlFor="time_slot_information">Time:</label>
                <input
                  className="w-full"
                  type="time"
                  name="time_slot_information"
                  value={formData.time_slot_information}
                  onChange={handleInputChange}
                  placeholder="Time"
                  style={{
                    padding: "10px",
                    // borderRadius: "4px",
                    // border: "1px solid #ccc",
                    ...(formErrors.time_slot_information && {
                      backgroundColor: "#ff000040",
                      border: "1px solid red",
                    }),
                  }}
                />
              </div>
            </div>

            <div className="flex flex_gap_10">
              <div className="w-full">
                <label htmlFor="guide_required">Do you need Guide:</label>
                <select
                  style={{
                    padding: "10px",
                    ...(formErrors.guide_required && {
                      backgroundColor: "#ff000040",
                      border: "1px solid red",
                    }),
                  }}
                  className="w-full"
                  name="guide_required"
                  value={formData.guide_required}
                  onChange={handleInputChange}
                >
                  <option value="" disabled>
                    Select an option
                  </option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>

            <div className={styles.package_query_input_100}>
              <label htmlFor="content">Query Detail:</label>
              <textarea
                className="w-full"
                type="text-area"
                name="content"
                value={formData.content}
                onChange={handleInputChange}
                placeholder="Querry Detail"
                style={{
                  padding: "10px",
                  // borderRadius: "4px",
                  // border: "1px solid #ccc",
                  ...(formErrors.content && {
                    backgroundColor: "#ff000040",
                    border: "1px solid red",
                  }),
                }}
              />
            </div>
            <div className="">
              <button type="submit" className={styles.common_btn}>
                SEND
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ActivityQueryFormPopup;
